import { useState, useEffect } from 'react';
import { Group, Paper, Stack, Text } from '@mantine/core';
import { useNavigate } from 'react-router';
import { useDealReportRepository } from '../../rpc';
import logger from '@ayocore/platform/common/helpers/logger';
import { buildDealsListUrl } from './buildDealsListUrl';

const fmt = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 });

const glassStyle = {
  background: 'rgba(255, 255, 255, 0.28)',
  backdropFilter: 'blur(12px)',
  WebkitBackdropFilter: 'blur(12px)',
  border: 'none',
} as const;

interface DealStatItem {
  id: number;
  name: string;
  color: string;
  total: number;
}

/**
 * Блок сделок филиала текущего пользователя по статусам.
 */
export function BranchDealsWelcomeBlock() {
  const navigate = useNavigate();
  const dealReportRepository = useDealReportRepository();
  const [data, setData] = useState<{
    branchName: string;
    branchId: number;
    stats: DealStatItem[];
  } | null>(null);

  useEffect(() => {
    dealReportRepository
      .getWelcomeBranchDealStats()
      .then(result => {
        if (result)
          setData(result as { branchName: string; branchId: number; stats: DealStatItem[] });
      })
      .catch(err => logger.error('Failed to load branch deal stats:', err));
  }, []);

  if (!data) return null;

  return (
    <Paper p='md' radius='lg' style={glassStyle}>
      <Stack gap='sm'>
        <Text size='xs' fw={500}>
          Сделки филиала: {data.branchName}
        </Text>
        <Group gap='xl' wrap='nowrap'>
          {data.stats.map(item => (
            <Stack
              key={item.name}
              gap={0}
              onClick={() =>
                navigate(buildDealsListUrl({ statusId: item.id, branchId: data.branchId }))
              }
              style={{
                flex: 1,
                minWidth: 0,
                backgroundColor: '#ffffff5e',
                padding: '6px 8px',
                borderRadius: 8,
                cursor: 'pointer',
              }}
            >
              <Text size='xs' c='dimmed'>
                {item.name}
              </Text>
              <Text size='sm' fw={600}>
                {fmt.format(item.total)} ₽
              </Text>
            </Stack>
          ))}
        </Group>
      </Stack>
    </Paper>
  );
}
